// src/components/LoginForm.jsx

import React, {
  useEffect,
  useState,
} from "react";

import {
  useHistory,
  Redirect,
} from "react-router-dom";

import {
  postLogin,
} from "../helpers/rutaUsuarios";

import "../css/loginform.css";

const LoginForm = () => {
  const history =
    useHistory();

  const [
    formValues,
    setFormValues,
  ] = useState({
    email: "",
    password: "",
  });

  const [
    user,
    setUser,
  ] = useState({
    data: {
      ok: null,
    },
    loading: false,
  });

  const [
    isLoggedIn,
    setIsLoggedIn,
  ] = useState(
    !!localStorage.getItem(
      "token"
    )
  );

  /* =====================================================
     LOGIN EXITOSO
  ===================================================== */

  useEffect(() => {
    if (user.data.ok) {

      localStorage.setItem(
        "token",
        user.data.token
      );

      localStorage.setItem(
        "id",
        user.data.usuario._id
      );

      localStorage.setItem(
        "usuario",
        JSON.stringify(
          user.data.usuario.nombres
        )
      );

      setIsLoggedIn(true);

      history.push("/");
    }
  }, [
    user,
    history,
  ]);

  /* =====================================================
     INACTIVIDAD
  ===================================================== */

  const logout = () => {
    localStorage.clear();

    setIsLoggedIn(false);

    history.push(
      "/login"
    );
  };

  const resetTimer = () => {
    clearTimeout(
      window.inactivityTimeout
    );

    window.inactivityTimeout =
      setTimeout(
        logout,
        60 * 100000
      );
  };

  useEffect(() => {
    window.addEventListener(
      "mousemove",
      resetTimer
    );

    window.addEventListener(
      "keydown",
      resetTimer
    );

    return () => {
      window.removeEventListener(
        "mousemove",
        resetTimer
      );

      window.removeEventListener(
        "keydown",
        resetTimer
      );

      clearTimeout(
        window.inactivityTimeout
      );
    };
  }, []);

  /* =====================================================
     FORMULARIO
  ===================================================== */

  const handleChange = (
    e
  ) => {
    setFormValues({
      ...formValues,
      [e.target.name]:
        e.target.value,
    });
  };

  const handleSubmit = (
    e
  ) => {
    e.preventDefault();

    setUser(
      (u) => ({
        ...u,
        loading: true,
      })
    );

    postLogin(
      formValues
    ).then(
      (datos) =>
        setUser(datos)
    );

    setFormValues({
      email: "",
      password: "",
    });
  };

  if (isLoggedIn) {
    return (
      <Redirect to="/" />
    );
  }

  return (
    <div className="danlu-login-form-wrap">

      <form
        onSubmit={
          handleSubmit
        }
        className="danlu-login-form"
      >

        <div className="danlu-login-field">

          <label htmlFor="email">
            Correo electrónico
          </label>

          <input
            id="email"
            type="email"
            name="email"
            value={
              formValues.email
            }
            onChange={
              handleChange
            }
            required
            autoFocus
            autoComplete="email"
            placeholder="usuario@correo.com"
          />

        </div>

        <div className="danlu-login-field">

          <label htmlFor="password">
            Contraseña
          </label>

          <input
            id="password"
            type="password"
            name="password"
            value={
              formValues.password
            }
            onChange={
              handleChange
            }
            required
            autoComplete="current-password"
            placeholder="Ingresá tu contraseña"
          />

        </div>

        <button
          type="submit"
          className="danlu-login-submit"
          disabled={
            user.loading
          }
        >
          {user.loading
            ? "Validando..."
            : "Iniciar sesión"}
        </button>

      </form>

      {user.data.ok ===
        false && (
        <div className="danlu-login-alert">
          {user.data.err
            ?.message ||
            "Error al iniciar sesión"}
        </div>
      )}

    </div>
  );
};

export default LoginForm;